import type { StarterPromptKind } from '@/lib/starter-prompts';

/** Which icon a starting point gets. Company starter questions are ordered —
 * recall knowledge, optional public research, then enrich company context — so
 * position decides, never keywords in the generated text. That order is a
 * contract of those questions alone: Skills worth adding have no order, each
 * one is a Skill to create. */
export type StartingPointIconName = 'skill' | 'app' | 'knowledge' | 'research' | 'enrich';

export function startingPointIcon(
  kind: StarterPromptKind,
  index: number,
  total: number,
): StartingPointIconName {
  if (kind === 'skill') return 'skill';
  if (index === 0) return 'knowledge';
  return index === total - 1 ? 'enrich' : 'research';
}
